export const VisaTypeKeys = {
key1: "student",
key2: "work",
key3: "visitor"
}